import React from 'react'

interface GenericCardContentProps {
  children?: React.ReactNode
}

export const GenericCardContent: React.FC<GenericCardContentProps> = ({
  children
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {children}
    </div>
  )
}
